// client/src/routes/app/dashboard.tsx — SCR-DASH-001 · FIN-005 (04 §8.2).
//
// Replaces UI-003's `PlaceholderScreen`, which was here so that its „all V1 module routes exist
// in the sidebar, may point to placeholder pages" criterion would be literally true, and which
// named this item as its owner.
//
// The route owns the URL and nothing else. There are no search params: the payload takes no
// parameters by design (D-859 — spec §4 names its own windows, and a period parameter would
// turn one cached document per organization into one per query string), so there is no list
// state for §9.2.3 to validate.
//
// `Reports.Read`, which is the code the three report routes it reads are behind and the one
// 03 §17.1 describes as „Vizualizare rapoarte și dashboard". 04 §6.2 leaves the sidebar entry
// open to „any org member", so a member without the permission still SEES „Panou general" and
// lands here — which is why the guard renders SCR-SYS-403 inside the shell (§9.2.2) rather than
// the entry being hidden. See DEVIATIONS D-735.

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { DashboardScreen } from '@/features/dashboard/DashboardScreen';

export const Route = createFileRoute('/app/dashboard')({
  component: DashboardRoute,
});

function DashboardRoute() {
  return (
    <RequirePermission permission="Reports.Read">
      <DashboardScreen />
    </RequirePermission>
  );
}
